import React from 'react';
import { colors, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { IIRSA_ITEMS } from "../Navbar/constants";
import MapIcon from "@mui/icons-material/Map";
import HomeIcon from "@mui/icons-material/Home";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import road from "~assets/road.png";
import charts from "~assets/charts.png";
import style from './styles.module.scss';
import { useNavigate, useLocation } from "react-router-dom";
import ROUTES from "~constants/routes";
import { Drawer as MuiDrawer } from "./styled";
import { white } from '~utils/colors';
import Tooltip from '@mui/material/Tooltip';
import i18next from 'i18next';

interface Props {
    open: boolean;
    closeDrawer: () => void;
    openDrawer: () => void;
}

const Drawer = ({ open, closeDrawer, openDrawer }: Props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const getIcon = (iconName: string | undefined, isActive: boolean) => {
        const fillcolor = isActive ? 'black' : 'white';
        switch (iconName) {
            case 'home':
                return <HomeOutlinedIcon style={{color: fillcolor}}/>;
            case 'map':
                return <PublicOutlinedIcon style={{color: fillcolor}}/>;
            case 'back':
                return <ArrowBackIcon style={{color: fillcolor}}/>;
            case 'forward':
                return <ArrowForwardIcon style={{color: fillcolor}}/>;
            case 'road':
                return <SpaceDashboardOutlinedIcon style={{color: fillcolor}}/>;
            case 'projects':
                return <FormatListBulletedOutlinedIcon style={{color: fillcolor}}/>;
            case 'charts':
                return <BarChartOutlinedIcon style={{color: fillcolor}}/>;
            default:
                return <></>;
        }
    }

    const navigateTo = (path: string) => {
        navigate(path);
    }

    const backToHome = () => {
        navigateTo(ROUTES.ROUTES_MAP);
    }

    const switchOpenSate = () => {
        if (open) {
            closeDrawer();
        }
        else {
            openDrawer();
        }
    }


    return (
        <MuiDrawer variant="permanent" open={open}
            classes={{
                paper: style.drawer
            }}>
            <div style={{ height: '90px' }}></div>
            <List classes={{
                root: style.drawerList

            }}>
                {IIRSA_ITEMS.map((item, index) => {
                    const isActive = location.pathname === item.pathname;
                    return (
                        <ListItem key={item.pathname} onClick={() => navigateTo(item.pathname)}>
                            <Tooltip title={item.name}>
                                <ListItemButton
                                    aria-label={String(item.name)}
                                    sx={[
                                        {
                                            minHeight: 48,
                                            px: 2.5,
                                        },
                                        open
                                            ? {
                                                justifyContent: 'initial',
                                            }
                                            : {
                                                justifyContent: 'center',
                                            },
                                    ]}>
                                    <ListItemIcon
                                        className={style.drawerListIcon}
                                        sx={[
                                            {
                                                minWidth: 0,
                                                justifyContent: 'center',
                                                padding: '8px',
                                                borderRadius: '50%',
                                                transition: 'all 0.3s ease',
                                            },
                                            open
                                                ? {
                                                    mr: 3,
                                                }
                                                : {
                                                    mr: 'auto',
                                                },
                                            isActive && {
                                                backgroundColor: '#FFF'
                                            },
                                        ]}>
                                        {getIcon(item.iconName, isActive)}
                                    </ListItemIcon>
                                <ListItemText primary={item.name} className={style.drawerListItem} hidden={!open} />
                            </ListItemButton>
                        </Tooltip>
                    </ListItem>
                    );
                })}
            </List>
            <Divider style={{
                marginLeft: '10px',
                marginRight: '10px',
                backgroundColor: 'white'
            }} />
            <List classes={{
                root: style.drawerList

            }}>
                <ListItem button key={'back-to-home'} onClick={switchOpenSate}>
                    <Tooltip title={open ? i18next.t('drawer:close') : i18next.t('drawer:open')}>
                        <ListItemButton
                            sx={[
                                {
                                    minHeight: 48,
                                    px: 2.5,
                                },
                                open
                                    ? {
                                        justifyContent: 'end',
                                    }
                                    : {
                                        justifyContent: 'center',
                                    },
                            ]}>
                            <ListItemIcon
                                className={style.drawerListIcon}
                                sx={[
                                    {
                                        justifyContent: 'center',
                                        minWidth: 0,
                                    },
                                    open
                                        ? {
                                            mr: 0,
                                        }
                                        : {
                                            mr: 'auto',
                                        },
                                ]}>
                                {open ? getIcon('back', false) : getIcon('forward', false)}
                            </ListItemIcon>
                            {/* <ListItemText primary={'Volver al home'} className={style.drawerListItem}/> */}
                        </ListItemButton>
                    </Tooltip>
                </ListItem>
            </List>
        </MuiDrawer>
    );
}

export default Drawer;